module.exports = {"width":100,"height":100,"url":"/static/media/spinner.66d7e40b.gif"};